import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

/**
 * Checks that the "Abregelbare Leistung KW" is not greater than the "installierte Leistung KW"
 */
@Directive(
    {
        selector: '[tnbAbregelbareLeistungLowerThanInstallierte]',
        providers: [
            {
                provide: NG_VALIDATORS,
                useExisting: AbregelbareLeistungLowerEqualsInstallierteValidatorDirective,
                multi: true,
            },
        ],
        standalone: false,
    },
)
export class AbregelbareLeistungLowerEqualsInstallierteValidatorDirective implements Validator {

    public static ERROR_KEY = 'abregelbareLeistungLowerEqualsInstallierte';

    @Input() tnbAbregelbareLeistungLowerThanInstallierte: string;

    validate(abregelbareLeistungControl: AbstractControl): ValidationErrors | null {
        if (this.tnbAbregelbareLeistungLowerThanInstallierte !== null && typeof this.tnbAbregelbareLeistungLowerThanInstallierte !== 'undefined' &&
            parseFloat(this.tnbAbregelbareLeistungLowerThanInstallierte) < parseFloat(abregelbareLeistungControl.value)) {
            const validationErrors = {};
            validationErrors[AbregelbareLeistungLowerEqualsInstallierteValidatorDirective.ERROR_KEY] = true;
            return validationErrors;
        }
    }

}
